/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';
import { PresentationExportRequestCompositionType } from '../../types/PresentationExportRequestCompositionType';

export const PresentationExportRequest: core.serialization.Schema<
    serializers.PresentationExportRequest.Raw,
    Truvity.PresentationExportRequest
> = core.serialization.object({
    compositionType: core.serialization.property('composition_type', PresentationExportRequestCompositionType),
    credentialIds: core.serialization.property('credential_ids', core.serialization.list(core.serialization.string())),
    holder: core.serialization.string(),
});

export declare namespace PresentationExportRequest {
    export interface Raw {
        composition_type: PresentationExportRequestCompositionType.Raw;
        credential_ids: string[];
        holder: string;
    }
}
